import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowDown } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'
import useDynamicHeight from '@/hooks/useDynamicHeight/useDynamicHeight'
import { useToggle } from '@/hooks/useToggle/useToggle'

import Styles from './Expandable.module.scss'

interface IExpandableProps {
  children: React.ReactNode
}

const Expandable: React.FC<IExpandableProps> = ({ children }) => {
  const { t } = useTranslation()

  const [open, toggle] = useToggle(false)

  const [shouldShowArrow, setShouldShowArrow] = useState(false)
  const overflowRef = useDynamicHeight<HTMLParagraphElement>()

  useEffect(() => {
    if (
      overflowRef.current &&
      overflowRef.current?.clientHeight !== overflowRef.current?.scrollHeight
    ) {
      setShouldShowArrow(true)
    }
  }, [overflowRef])

  return (
    <div
      className={clsx([
        Styles.expandable,
        open && Styles.open,
        shouldShowArrow && Styles.active
      ])}
      onClick={shouldShowArrow ? toggle : () => {}}
      data-testid="expandable">
      <div>
        <Text variant="nextCaption" className={Styles.title} gutter={4}>
          {t('orders.instruction')}
        </Text>
        <Text variant="body" className={Styles.description} ref={overflowRef}>
          {children}
        </Text>
      </div>
      {shouldShowArrow && (
        <div className={Styles.arrowWrapper}>
          <ArrowDown className={clsx([Styles.arrow])} />
        </div>
      )}
    </div>
  )
}

export default Expandable
